import gql from 'graphql-tag';
import { propertyServiceV5Client } from './analyticsAPIUtils';
import {
  getActivities,
  getActivityCategories,
  getActivityTags,
} from '../graphql/activity-calendar/queries';
import {
  CreateActivityCalendar,
  createActivityTag,
  deleteActivityTag,
  updateActivityList,
  updateActivityTag,
  deleteActivityData,
  handleDeactivate,
  CreateActivityCategory,
  UpdateActivityCategory,
  DeleteActivityCategory,
  UpdateActivityCategoryStatus,
} from '../graphql/activity-calendar/mutations';
import { getEncodedValue } from './authUtils';
import { propertyServiceV6Client } from './PropertyAPIUtils';

export const getActivityTagsList = async (hotelId, language) => {
  return await propertyServiceV5Client.query({
    query: gql(getActivityTags),
    variables: getEncodedValue({ hotelId, language }),
    fetchPolicy: 'network-only',
  });
};

export const createActivity = async (hotelId, name, language) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(createActivityTag),
    variables: getEncodedValue({
      hotelId,
      name,
      language,
    }),
  });
};

export const updateActivity = async (hotelId, name, id, language) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(updateActivityTag),
    variables: getEncodedValue({
      hotelId,
      name,
      id,
      language,
    }),
  });
};

export const deleteActivity = async (hotelId, id, language) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(deleteActivityTag),
    variables: getEncodedValue({
      hotelId,
      id,
      language,
    }),
  });
};

export const CreateActivityApi = async (payload, language) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(CreateActivityCalendar),
    variables: getEncodedValue({
      ...payload,
      language,
    }),
  });
};

export const getActivityList = async (hotelId, language) => {
  return await propertyServiceV5Client.query({
    query: gql(getActivities),
    variables: getEncodedValue({
      hotelId,
      language,
    }),
    fetchPolicy: 'network-only',
  });
};

export const UpdateActivityListApi = async (payload, id, language) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(updateActivityList),
    variables: getEncodedValue({
      ...payload,
      id,
      language,
    }),
  });
};

export const deleteActivityApi = async (hotelId, id, language) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(deleteActivityData),
    variables: getEncodedValue({
      hotelId,
      id,
      language,
    }),
  });
};

export const handleDeactivateApi = async (hotelId, id, language) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(handleDeactivate),
    variables: getEncodedValue({
      hotelId,
      id,
      language,
    }),
  });
};

export const CreateActivityCategoryAPI = async (payload, lang) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(CreateActivityCategory),
    variables: getEncodedValue({
      hotelId: payload?.hotelId,
      name: payload?.name,
      categoryCode: payload?.categoryCode,
      isActive: payload?.isActive,
      images: payload?.images,
      customAttributes: payload?.customAttributes,
      lang: lang,
    }),
  });
};

export const UpdateActivityCategoryAPI = async (payload, id, language) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(UpdateActivityCategory),
    variables: getEncodedValue({
      ...payload,
      id,
      lang: language,
    }),
  });
};

export const DeleteActivityCategoryAPI = async (hotelId, id, language) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(DeleteActivityCategory),
    variables: getEncodedValue({
      hotelId,
      id,
      lang: language,
    }),
  });
};

export const UpdateActivityCategoryStatusAPI = async (hotelId, id, language) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(UpdateActivityCategoryStatus),
    variables: getEncodedValue({
      hotelId,
      id,
      lang: language,
    }),
  });
};

export const getActivityCategoriesList = async (hotelId, language) => {
  return await propertyServiceV6Client.query({
    query: gql(getActivityCategories),
    variables: getEncodedValue({ hotelId, language }),
    fetchPolicy: 'network-only',
  });
};
